import React, {
    useEffect,
    useContext,
} from "react"

import {
    Context,
    EMETLContext,
} from "../Model/Contexts/AppContext"

import ViewAssessments from "./ViewAssessments"

const Templates = () => {
    const {
        assessmentData: {
            assessments: {
                value: assessments,
                update: setAssessments,
            },
        }
    } = useContext(Context) as EMETLContext
    
    useEffect(() => {
        if(!!assessments?.length)
            setAssessments([])
        
    }, [])
    return  (
        <ViewAssessments 
            wantsTemplates
        />
    )
}

export default Templates